// utils/downloadOlympiadPDF.js

import html2pdf from "html2pdf.js";
// import LogoMittsure from "../newLogo2204.PNG";
import LogoMittsure from '../logoForOrder.png';

const downloadOlympiadPDF = (data) => {
  console.log("Generating PDF with data:", data);

  if (!data) return;

  // ✅ Financial Year
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;

  let fyStartYear;
  let fyEndYear;

  if (month >= 4) {
    fyStartYear = year;
    fyEndYear = year + 1;
  } else {
    fyStartYear = year - 1;
    fyEndYear = year;
  }

  const fiscalYearRange = `${fyStartYear}-${String(fyEndYear).slice(-2)}`;

  // ✅ Safe JSON parse
  const parseJSON = (val) => {
    try {
      return JSON.parse(val || "[]");
    } catch {
      return [];
    }
  };

  // ✅ Coordinator mapping
  // const getCoordinator = (subject) => {
  //   const c = data.coordinators?.find(
  //     (x) => x.subject?.toLowerCase() === subject
  //   );
  //   return c ? `${c.name} / ${c.mobile}` : "-";
  // };

  const getCoordinator = (subject) => {
    if (subject == "9999") {
      const c = data.coordinators?.find(
        (x) => x.subId == "9999");
        
      return c ? `${"General Coordinator"} / ${c.mobile}` : "-";
    }
    const c = data.coordinators?.find(
      (x) => String(x.subject)?.toLowerCase() === String(subject)?.toLowerCase());

    return c ? `${c.name} / ${c.mobile}` : "N/A";
  };

  // ✅ Student Rows
  // const studentRows = data.studentRegistrationSummary
  //   ?.map(
  //     (row) => `
  //     <tr>
  //       <td>${row.class}</td>
  //       <td>${row.science || ""}</td>
  //       <td>${row.maths || ""}</td>
  //       <td>${row.english || ""}</td>
  //       <td>${row.gk_iq || ""}</td>
  //       <td>${row.reasoning || ""}</td>
  //     </tr>
  //   `
  //   )
  //   .join("");

  const studentRows = data.studentRegistrationSummary
    ?.filter(
      (row) =>
        Number(row.science || 0) > 0 ||
        Number(row.maths || 0) > 0 ||
        Number(row.english || 0) > 0 ||
        Number(row.gk_iq || 0) > 0 ||
        Number(row.reasoning || 0) > 0
    )
    .sort((a, b) => {
      const getClassNumber = (cls) =>
        parseInt(String(cls).replace(/[^0-9]/g, "")) || 0;

      return getClassNumber(a.class) - getClassNumber(b.class);
    })
    .map((row) => {
      const rowTotal =
        Number(row.science || 0) +
        Number(row.maths || 0) +
        Number(row.english || 0) +
        Number(row.gk_iq || 0) +
        Number(row.reasoning || 0);

      return `
      <tr>
        <td>${row.class}</td>
        <td>${row.science || 0}</td>
        <td>${row.maths || 0}</td>
        <td>${row.english || 0}</td>
        <td>${row.gk_iq || 0}</td>
        <td>${row.reasoning || 0}</td>
        <td><b>${rowTotal || 0}</b></td>
      </tr>
    `;
    })
    .join("");
  // ✅ Study Material Rows
  // const studyRows = data.studyMaterialSummary
  //   ?.map(
  //     (row) => `
  //     <tr>
  //       <td>${row.class}</td>
  //       <td>${row.science || ""}</td>
  //       <td>${row.maths || ""}</td>
  //       <td>${row.english || ""}</td>
  //       <td>${row.gk_iq || ""}</td>
  //       <td>${row.reasoning || ""}</td>
  //     </tr>
  //   `
  //   )
  //   .join("");

  const studyRows = data.studyMaterialSummary
    ?.filter(
      (row) =>
        Number(row.science || 0) > 0 ||
        Number(row.maths || 0) > 0 ||
        Number(row.english || 0) > 0 ||
        Number(row.gk_iq || 0) > 0 ||
        Number(row.reasoning || 0) > 0
    )
    .sort((a, b) => {
      const getClassNumber = (cls) =>
        parseInt(String(cls).replace(/[^0-9]/g, "")) || 0;

      return getClassNumber(a.class) - getClassNumber(b.class);
    })
    .map((row) => {
      const rowTotal =
        Number(row.science || 0) +
        Number(row.maths || 0) +
        Number(row.english || 0) +
        Number(row.gk_iq || 0) +
        Number(row.reasoning || 0);

      return `
      <tr>
        <td>${row.class}</td>
        <td>${row.science || 0}</td>
        <td>${row.maths || 0}</td>
        <td>${row.english || 0}</td>
        <td>${row.gk_iq || 0}</td>
        <td>${row.reasoning || 0}</td>
        <td><b>${rowTotal || 0}</b></td>
      </tr>
    `;
    })
    .join("");
    

    // ✅ Student totals per subject
const studentTotals = data.studentRegistrationSummary?.reduce(
  (acc, row) => {
    acc.science += Number(row.science || 0);
    acc.maths += Number(row.maths || 0);
    acc.english += Number(row.english || 0);
    acc.gk_iq += Number(row.gk_iq || 0);
    acc.reasoning += Number(row.reasoning || 0);
    return acc;
  },
  { science: 0, maths: 0, english: 0, gk_iq: 0, reasoning: 0 }
);

const studentGrandTotal =
  studentTotals.science + studentTotals.maths + studentTotals.english +
  studentTotals.gk_iq + studentTotals.reasoning;

  // ✅ Study material totals per subject
const studyTotals = data.studyMaterialSummary?.reduce(
  (acc, row) => {
    acc.science += Number(row.science || 0);
    acc.maths += Number(row.maths || 0);
    acc.english += Number(row.english || 0);
    acc.gk_iq += Number(row.gk_iq || 0);
    acc.reasoning += Number(row.reasoning || 0);
    return acc;
  },
  { science: 0, maths: 0, english: 0, gk_iq: 0, reasoning: 0 }
);

const studyGrandTotal =
  studyTotals.science + studyTotals.maths + studyTotals.english +
  studyTotals.gk_iq + studyTotals.reasoning;


    const formatDate = (date) => {
        if (!date) return "N/A";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };

      const formatDate1 = (dateStr) => {
        if (!dateStr) return "N/A";

        const date = new Date(dateStr);

        if (isNaN(date)) return "N/A";

        return date.toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            // hour: "2-digit",
            // minute: "2-digit",
            // second: "2-digit",
            // hour12: true
        });
    };

     const safe = (val) => {
        return val !== undefined &&
            val !== null &&
            val !== ""
            ? val
            : "-";
    };
 const currency = (val) => {
        return `₹${Number(val || 0).toLocaleString("en-IN")}`;
    };
     // =========================
    // Transactions
    // =========================
    const transactionRows = (data.schoolInfo?.transactions || [])
        ?.map((txn, index) => {
            return `
                <tr>
                    <td style="padding:6px;">
                        ${index + 1}
                    </td>

                    <td style="padding:1px; word-break:break-word;overflow-wrap:break-word;">
                        ${safe(txn?.transactionReference)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(txn?.payment_mode_name)}
                    </td>

                    <td style="padding:6px;">
                        ${formatDate(txn?.transactionDate)}
                    </td>

                    <td style="padding:6px;">
                        ${currency(txn?.paidAmount)}
                    </td>

                    <td style="padding:6px;">
                        ${safe(txn?.transactionStatus)}
                    </td>
                </tr>
            `;
        })
        ?.join("");

        
  const htmlContent = `
  <div style="padding:2px; font-family: Arial; font-size:13px;">

    <!-- HEADER -->
    <div style="display:flex; justify-content:space-between; align-items:center;">
      <img src="${LogoMittsure}" style="width:150px"/>
      <div>
        <p><b style="font-size:'11px'">Date:</b> ${formatDate1(data.schoolInfo.createdAt)}</p>
        <p><b>RNO #:</b> ${data.schoolInfo.rno_id}</p>
      </div>
    </div>

    <p style="text-align:center; font-size:19px; font-weight:600; color:#000;">Mittsure Technologies LLP</p>
    <p style="text-align:center; margin-top:2px; padding:0px;font-size:15px; color:#000; font-weight:600">MOM Registration Details (${fiscalYearRange})</p>

    <!-- SCHOOL DETAILS -->
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <td><b  style="color:#000; font-weight:600;">MOM School Code: </b> <span style="color:#000; font-weight:500; font-size:12px;" >${data.schoolInfo.partyId || "N/A"}</span></td>
        <td><b style="color:#000; font-weight:600;">District Code:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${data.schoolInfo.mom_district_code || "N/A"}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">School Name:</b><span style="color:#000; font-weight:500; font-size:12px;" > ${data.schoolInfo.schoolName}</span></td>
        <td><b style="color:#000; font-weight:600;">State:</b><span style="color:#000; font-weight:500; font-size:12px;" > ${data.schoolInfo.schoolState || "N/A"}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">RM/ARM:</b> <span style="color:#000; font-weight:500; font-size:12px;" > ${data.schoolInfo.userName} ${data.schoolInfo.userName1 ? ` - (${data.schoolInfo.userName1})` : ''}</span></td>
        <td><b style="color:#000; font-weight:600;">RM Contact:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${data.schoolInfo.userMobileNumber || "N/A"}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">Registration Type:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${data.schoolInfo.RegistrationType || "N/A"}</span></td>
        <td><b style="color:#000; font-weight:600;">Date of Olympiad:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${formatDate(data.schoolInfo.olympiad_date)}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">Medium:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${data.schoolInfo.reg_medium_name || "N/A"}</span></td>
        <td><b style="color:#000; font-weight:600;">Mode of Payment:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${parseJSON(
    data.schoolInfo.mode_of_payment
  ).join(", ")}</span></td>  
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">Order Status:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${data.schoolInfo.transactionStatus || "N/A"}</span></td>
        <td><b style="color:#000; font-weight:600;">Sci Coordinator:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${getCoordinator("science")}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">Maths Coordinator:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${getCoordinator("maths")}</span></td>
        <td><b style="color:#000; font-weight:600;">Eng Coordinator:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${getCoordinator("english")}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">GK Coordinator:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${getCoordinator("gk_id")}</span></td>
        <td><b style="color:#000; font-weight:600;">Reasoning Coordinator:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${getCoordinator("reasoning")}</span></td>
      </tr>
       <tr>
        <td><b style="color:#000; font-weight:600;">General Coordinator:</b> <span style="color:#000; font-weight:500; font-size:12px;" >${getCoordinator("9999")}</span></td>
      </tr>
    </table>
    <p style="margin-top:2px;"><b style="color:#000; font-weight:600;">Last Transaction Remark:</b> ${data.schoolInfo.transactions[0]?.transaction_remark || "N/A"}</p>
    <p style="margin-top:2px;"><b style="color:#000; font-weight:600;">Admin Remark:</b> ${data.schoolInfo.adminRemark || "N/A"}</p>

    <h4 style="color:#000; font-weight:600;">Student Registration Details</h4>
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <th style="padding:6px; background:#dce3dd; color:#000;">Class</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Science</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Maths</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">English</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">GK & IQ</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Reasoning</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total</th>
      </tr>
      ${studentRows}
      <tr style="background:#f0f4f0;">
  <td><b>Total</b></td>
  <td><b>${studentTotals.science || 0}</b></td>
  <td><b>${studentTotals.maths || 0}</b></td>
  <td><b>${studentTotals.english || 0}</b></td>
  <td><b>${studentTotals.gk_iq || 0}</b></td>
  <td><b>${studentTotals.reasoning || 0}</b></td>
  <td><b>${studentGrandTotal || 0}</b></td>
</tr>
    </table>

    <p style="font-weight:600; color:#000;"><b>Total Registration Amount:</b> ₹${data.registrationTotals.totalAmount}</p>


    <h4 style="color:#000; font-weight:600;">Study Material Details</h4>
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <th style="padding:6px; background:#dce3dd; color:#000;">Class</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Science</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Maths</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">English</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">GK & IQ</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Reasoning</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total</th>
      </tr>
      ${studyRows}
      <tr style="background:#f0f4f0;">
  <td><b>Total</b></td>
  <td><b>${studyTotals.science || 0}</b></td>
  <td><b>${studyTotals.maths || 0}</b></td>
  <td><b>${studyTotals.english || 0}</b></td>
  <td><b>${studyTotals.gk_iq || 0}</b></td>
  <td><b>${studyTotals.reasoning || 0}</b></td>
  <td><b>${studyGrandTotal || 0}</b></td>
</tr>
    </table>

    <p style="font-weight:600; color:#000;"><b>Total Books Amount:</b> ₹${data.studyMaterialTotals.totalAmount}</p>

    <h4 style="color:#000; font-weight:600;">Payment Details</h4>
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total Registration Amount</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total Study Material Amount</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total Payable Amount</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total Paid Amount</th>
      </tr>
      <tr>
        <td  style="color:#000; font-weight:600;">₹${data.paymentSummary.registrationAmount || 0}</td>
        <td  style="color:#000; font-weight:600;">₹${data.paymentSummary.studyMaterialAmount || 0}</td>
        <td  style="color:#000; font-weight:600;">₹${data.paymentSummary.totalPayableAmount || 0}</td>
        <td  style="color:#000; font-weight:600;">₹${data.paymentSummary.totalPaidAmount || 0}</td>
      </tr>
    </table>

            <h4 style="margin-bottom:5px; color:#000; font-weight:600;">
                Transaction Details
            </h4>
<div style="width:100%; overflow-x:auto;">
            <table border="1" style="width:100%; border-collapse:collapse; margin-bottom:15px;table-layout:fixed;">

                <tr>
                    <th style="padding:6px; background:#dce3dd; color:#000; width:100px; min-width:100px;">#</th>
                    <th style="padding:6px; background:#dce3dd; color:#000; width:250px; min-width:200px;">Reference No.</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Payment Mode</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Date</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Amount</th>
                    <th style="padding:6px; background:#dce3dd; color:#000;">Status</th>
                </tr>

                ${transactionRows || `
                    <tr>
                        <td colspan="6"
                            style="padding:10px; text-align:center; color:#000; font-weight:600;">
                            No Transactions Available
                        </td>
                    </tr>
                `}
            </table>

  </div>
  `;

  const element = document.createElement("div");
  element.innerHTML = htmlContent;

  // html2pdf()
  //   .set({
  //     margin: 5,
  //     filename: `Olympiad_${data.schoolInfo.rno_id}.pdf`,
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
  //   })
  //   .from(element)
  //   .save();
  const options = {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: 'Order_form.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, logging: true, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a3', orientation: 'portrait' }
      };
      html2pdf()
        .set(options)
        .from(element)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
  
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(0, 0, 0);
  
            pdf.text(
              `Page ${i} of ${totalPages}`,
              pageWidth - 1.5,
              pageHeight - 0.3
            );
          }
        })
        .save(`Olympiad_${data?.schoolInfo?.rno_id || 'Registration'}.pdf`)
        .then(() => {
          document.body.removeChild(element);
        });
};

export default downloadOlympiadPDF;